// CB:BEGIN ui-bottomsheet
import React, { useEffect } from 'react';

interface BottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
}

const BottomSheet: React.FC<BottomSheetProps> = ({ isOpen, onClose, title, children }) => {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', onKey);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div role="dialog" aria-modal="true" style={{ position: 'fixed', inset: 0, zIndex: 1000 }}>
      <div onClick={onClose} style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.45)' }} />
      <div
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
          background: 'white',
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          padding: '16px 16px calc(16px + env(safe-area-inset-bottom)) 16px',
          boxShadow: '0 -10px 30px rgba(0,0,0,0.2)',
          maxHeight: '80svh',
          overflowY: 'auto',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 8 }}>
          <div style={{ width: 40, height: 4, borderRadius: 999, background: '#e5e7eb' }} />
        </div>
        {title ? <div style={{ fontWeight: 700, marginBottom: 8 }}>{title}</div> : null}
        {children}
      </div>
    </div>
  );
};

export default BottomSheet;
// CB:END ui-bottomsheet

